/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UiNodeImageAttributes { 
    /**
     * Height of the image
     */
    height: number;
    /**
     * A unique identifier
     */
    id: string;
    /**
     * NodeType represents this node\'s types. It is a mirror of `node.type` and is primarily used to allow compatibility with OpenAPI 3.0.  In this struct it technically always is \"img\". text Text input Input img Image a Anchor script Script
     */
    node_type: UiNodeImageAttributes.NodeTypeEnum;
    /**
     * The image\'s source URL.  format: uri
     */
    src: string;
    /**
     * Width of the image
     */
    width: number;
}
export namespace UiNodeImageAttributes {
    export type NodeTypeEnum = 'text' | 'input' | 'img' | 'a' | 'script';
    export const NodeTypeEnum = {
        Text: 'text' as NodeTypeEnum,
        Input: 'input' as NodeTypeEnum,
        Img: 'img' as NodeTypeEnum,
        A: 'a' as NodeTypeEnum,
        Script: 'script' as NodeTypeEnum
    };
}


